import cookies from './cookie.js'
import axios from '../axios'
const role = {}
const cookiesName = 'kx_user_message' // 信息cookie的key
const userMenus = 'kx_role_menu'

/**
 * @method
 * 存入用户的登录信息
 */
role.saveCookies = function (data, time) {
  cookies.set(cookiesName, escape(JSON.stringify(data)), time)
}
/**
 * @method
 * 返回用户的登录信息
 */
role.showCookies = function () {
  let c = cookies.get(cookiesName)
  return c ? JSON.parse(unescape(c)) : null
}
role.deleteCookies = function () {
  cookies.delete(cookiesName)
}
/**
 * @method
 * 存入vue的全局变量
 */
role.saveGlobal = function (arr) {
  if (arr) {
    global.userId = arr.id
    global.type = arr.type
    global.userName = arr.type === 5 ? arr.staff_name : arr.user_name
    global.userTel = arr.type === 5 ? arr.staff_tel : arr.user_tel
    global.pid = arr.pid
    if (arr.type !== 5) {
      global.level = arr.level
      global.region = arr.region
      global.balance = arr.balance
      global.discount = arr.discount
      global.province_id = arr.province_id
      global.city_id = arr.city_id
      global.capacity_status = arr.capacity_status
    } else {
      global.p_type = arr.p_type
      global.qrcode = arr.qrcode
    }
  } else {
    global.userId = 0
    global.type = 0
    global.userName = 0
    global.userTel = 0
    global.pid = 0
    global.level = 0
    global.region = 0
    global.balance = 0
    global.discount = 0
    global.province_id = 0
    global.city_id = 0
    global.p_type = 0
  }
}
role.setRoleMenu = function (str) {
  localStorage.setItem(userMenus, JSON.stringify(str))
}

role.getRoleMenu = function () {
  let result = localStorage.getItem(userMenus)
  return result ? JSON.parse(result) : null
}
role.removeRoleMenu = function () {
  localStorage.removeItem(userMenus)
}
/**
 * @method
 * 获取订单来源
 */
role.orderSource = function () {
  localStorage.removeItem('orderSource')
  axios.post(global.HTTP + 'common/orderSource', { user_id: global.userId, user_type: global.type })
    .then(function (resp) {
      if (resp.data.code === 0) {
        localStorage.setItem('orderSource', JSON.stringify(resp.data.data))
      } else {
        console.log(resp.data.msg)
        return null
      }
    })
    .catch(function (err) {
      console.log(err)
      return null
    })
}
/**
 * @method
 * 获取订单配送方式
 */
role.orderDelivery = function () {
  localStorage.removeItem('orderDelivery')
  axios.get(global.HTTP + 'capacity/capacityCate')
    .then(function (resp) {
      if (resp.data.code === 0) {
        localStorage.setItem('orderDelivery', JSON.stringify(resp.data.data))
      } else {
        console.log(resp.data.msg)
        return null
      }
    })
    .catch(function (err) {
      console.log(err)
      return null
    })
}
/**
 * @method
 * 获取当前用户对应的代理商列表
 */
role.agentList = function () {
  localStorage.removeItem('agentList')
  axios.post(global.HTTP + 'agent/agentList', { user_id: global.userId, user_type: global.type, flag: 1 })
    .then(function (resp) {
      if (resp.data.data && resp.data.code === 0) {
        let arr = []
        for (var i = 0; i < resp.data.data.length; i++) {
          arr[i] = {
            label: resp.data.data[i].user_name,
            value: resp.data.data[i].id
          }
        }
        localStorage.setItem('agentList', JSON.stringify(arr))
      } else {
        console.log(resp.data.msg)
        return null
      }
    })
    .catch(function (err) {
      console.log(err)
      return null
    })
}
/**
 * @method
 * 获取当前用户对应的销售列表
 */
role.sellerList = function () {
  localStorage.removeItem('sellerList')
  axios.post(global.HTTP + 'common/sellerList', { user_id: global.userId, user_type: global.type })
    .then(function (resp) {
      if (resp.data.code === 0) {
        global.sellerList = resp.data.data
        localStorage.setItem('sellerList', JSON.stringify(resp.data.data))
      } else {
        console.log(resp.data.msg)
        return null
      }
    })
    .catch(function (err) {
      console.log(err)
      return null
    })
}
/**
 * @method
 * 获取当前用户对应的地区列表
 */
role.regionList = function () {
  localStorage.removeItem('regionList')
  axios.post(global.HTTP + 'common/regionList', { user_id: global.userId, user_type: global.type })
    .then(function (resp) {
      if (resp.data.code === 0) {
        global.regionList = resp.data.data
        localStorage.setItem('regionList', JSON.stringify(resp.data.data))
      } else {
        console.log(resp.data.msg)
        return null
      }
    })
    .catch(function (err) {
      console.log(err)
      return null
    })
}
/**
 * @method
 * 获取当前用户对应的代理商层级
 */
role.agentLevel = function () {
  localStorage.removeItem('agentLevel')
  axios.post(global.HTTP + 'common/agentLevel', { user_id: global.userId, user_type: global.type })
    .then(function (resp) {
      if (resp.data.code === 0) {
        global.agentLevel = resp.data.data
        localStorage.setItem('agentLevel', JSON.stringify(resp.data.data))
      } else {
        console.log(resp.data.msg)
        return null
      }
    })
    .catch(function (err) {
      console.log(err)
      return null
    })
}
/**
 * @method
 * 获取页面的url参数（不是vue的url参数）
 */
role.GetQueryString = function (name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg) // search,查询？后面的参数，并匹配正则
  if (r != null) return unescape(r[2])
  return null
}

/**
 * @method
 * 获取vue页面的url参数
 */
role.GetVueQueryString = function (name) {
  var reg = new RegExp(name + '=([^&]*)(&|$)')
  var r = window.location.hash.substr(1).match(reg) // search,查询？后面的参数，并匹配正则
  if (r != null) return unescape(r[1])
  return null
}

/**
 *
 * @param {string} str 需要比较的路径
 * @param {array} arr 传入公共的路由数组
 * @param {array} roles 传入公共的路由数组
 */
role.filter = function (str, arr, roles = []) {
  if (arr !== undefined) {
    // 如果arr存在的话，进行合并数组
    roles = roles.concat(arr)
  }
  for (let i = 0; i < roles.length; i++) {
    if (roles[i] === str) {
      // 如果匹配到传过来的str，直接return true
      return true
    }
  }
  // for循环完毕，没有匹配到路由
  return false
}
export default role



// WEBPACK FOOTER //
// ./src/common/role.js